import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import styles from "../../styles/Product.module.css";
import Product_comp from "@/comps/Product_comp";
import {
  products
} from "@/data/products";
import Meta from "@/comps/Meta";
import { useTranslation } from "react-i18next";
import { Star, UserCircle } from "lucide-react";

const Product = () => {

  const [t, i18n] = useTranslation();
  const { language } = i18n;

  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageWidth, setImageWidth] = useState(750);
  const [imageHight, setImageHight] = useState(550);

  const [imageWidthTwo, setImageWidthTwo] = useState(1150);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1280px)");

    function handleMediaChange(event) {
      if (event.matches) {
        setImageWidth(400);
        setImageHight(300);

        setImageWidthTwo(400);
      } else {
        setImageWidth(750);
        setImageHight(500);

        setImageWidthTwo(1150);
      }
    }

    mediaQuery.addListener(handleMediaChange);

    return () => {
      mediaQuery.removeListener(handleMediaChange);
    };
  }, []);

  const router = useRouter();

  const { id } = router.query;

  const product = products.find((item) => item.id === Number(id));

  const visibleProducts = products.slice(currentIndex, currentIndex + 3);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 3 >= products.length ? 0 : prevIndex + 3
      );
    }, 60000);

    return () => clearInterval(interval);
  }, [products.length]);

  const truncatedDesc =
    product?.desc.length > 100
      ? product?.desc.substring(0, 100) + "..."
      : product?.desc;

  const mailtoLink = `mailto:info@sigmamachines.net?subject=Inquiry about ${product?.name}`;

  const phoneNumber = "+966569745955";
  // const message = "Hello, I am inquiring about from your website.";
  // const messageAr = " مرحباً، أود الاستفسار عن المنتَج المعروض على موقعكم الإلكتروني. ";
  // const refCode = `[Ref: WEB-${Date.now().toString().slice(-4)}]`;

  const refCode = `[Ref: WEB-${Date.now().toString().slice(-4)}]`;
  const productName = language === "en" ? product?.name : product?.nameAr;
  const message = language === "en"
    ? `Hello, I am inquiring about (${productName}) from your website.`
    : `مرحباً، أود الاستفسار عن المنتج (${productName}) المعروض على موقعكم الإلكتروني.`;

  const fullText = `${message}\n\n${refCode}`;

  return (
    <>

      {/* <Meta
        // title={product?.TitleTag || product?.name}
        title={
          language === "en"
            ? product?.TitleTag || product?.name || product?.nameAr
            : product?.TitleTagAr || product?.nameAr || product?.name
        }
        description={`${product?.MetaDescription || product?.desc} , Explore a complete range of CNC Machine, CNC Routers, CNC Lathe Machines, Fiber Laser Cutting Machines, Plasma Cutting Machines, CO2 Laser Machines, Laser Welding Machines, Laser Marking Machines, Press Brake Bending Machines, Hydraulic Press Brakes, CNC Shearing Machines, Mechanical Shearing Machines, and Industrial Automation Solutions. Sigma Machines supplies advanced industrial machinery for metal fabrication, sheet metal processing, woodworking, manufacturing, and production facilities across Saudi Arabia and the Middle East.`}
        keywords={`${product?.Keywords} , CNC Machines, CNC Machine, CNC machines Saudi Arabia, Laser cutting machines KSA , CNC router supplier Saudi Arabia, Industrial machinery distributor, Fiber laser machines Middle East, CNC machines for metal fabrication, Laser welding systems for industry, CNC خشب , CNC إختصار , ماكينة CNC , Cnc mesrs dz , أشكال CNC , سعر ماكينة CNC , أنواع ماكينات CNC , Cnc ملابس , CNC online , Bystronic laser cutting machine price , Bystronic laser manual pdf , TRUMPF laser cutting machine , Fiber laser cutting machine , AMADA laser cutting machine , Laser Automation , Bystronic Bystar 3015 laser manual , Used tube laser , تجربتي_مع فراكشنال ليزر co2 , فراكشنال ليزر CO2 قبل وبعد , ماكينة ليزر CO2 , ماكينة ليزر CO2 , Fiber laser cutting table , Fiber laser cutting design , Fiber laser cutting near me , Fiber laser cutting machine , Fiber Laser Cutting Machine price , CNC Fiber Laser cutting Machine , Plasma cutting Machine , Plasma cutting CNC , Plasma Cutting Machine price , Plasma cutting temperature , Plasma cutting Torch , Plasma cutting working principle , cnc machine , cnc design , cnc stock , cnc operator , ماكينة cnc , cnc router , cnc lathe machine , cnc machines , modern cnc design , what is cnc , cnc machine operator , cnc خشب , Types of welding machines with pictures , 4 types of welding machines with pictures , 5 types of welding machines , Welding machines Types , Names of welding machines , Types of welding machines for beginners , 3 types of welding machines , Laser welding machines , Laser Marking Machine price , Laser marking machine for metal , Laser marking process , Laser marking near me , Laser marking video , Laser marking head , Laser Marking price , Laser Marking Products , Press brake process , Hydraulic Press brake , Press Brake Bending Machine , Press brake steel , Press Brake manufacturers , Press brake operator , Manual press brake , Press brake homemade , Shearing Machine price , Types of shearing machine , Shear Cutting Machine Manual , CNC shearing machine , Mechanical Shearing Machine , Shearing machine diagram , RapidChange ATC , ATC CNC machine price , Rapid change ATC for sale , RapidChange ATC DIY , ATC spindle adapter , RapidChange ATC 3D print , cnc machine operator , cnc machine price , cnc router machine , what is cnc , cnc laser cutting machine , cnc milling machine , cnc machines`}
        image={product?.image}
        url={`https://sigmamachines.net/products/${product?.id}`}
      /> */}
      <Meta
        title={
          language === "ar"
            ? product?.TitleTagAr || product?.nameAr || product?.name
            : product?.TitleTag || product?.name || product?.nameAr
        }
        description={
          language === "ar"
            ? product?.MetaDescriptionAr || product?.descAr
            : product?.MetaDescription || product?.desc
        }
        keywords={
          language === "ar"
            ? product?.KeywordsAr
            : product?.Keywords
        }
        image={product?.image}
        url={`https://sigmamachines.net/products/${product?.id}`}
      />
      <div dir={language === "en" ? "ltr" : "rtl"}>

        <section className="sr-only">
          <p>{product?.SEOContent}</p>
        </section>

        <div className="relative">
          <div className={`${styles.bg_products} `}>
            <p className="relative z-10 text-center text-3xl max-lg:text-xl text-white font-semibold pt-36 max-lg:pt-10 max-lg:px-5">
              {t("Sigma Machines Products")} ( {language === "en" ? product?.name : product?.nameAr} )
            </p>
            <p className="text-center lg:text-lg text-[#a9a9a9] mt-3 relative z-10 max-lg:px-5">
              {(language === "en" ? product?.overview : product?.overviewAr) || "HIGH SPEED, HIGH ACCURACY, HIGH EFFICIENCY"}
            </p>
          </div>

          {/* <div className="bg-[#00000085] h-[350px] w-full absolute top-0 z-0"></div> */}
        </div>

        <div className="px-24 max-lg:px-10">
          {/* {
          
          product?.id == "20"  ? (
          <p className="mt-5 mb-5 text-lg text-[#54545f]">{product?.desc}</p>
        ) : (
          ""
        )} */}

          {/* {
          
          product?.id == "21" ? (
          <>
             {
            // product?.id == "10" ? (
            //   <>
            //     <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-4 mt-9 mb-9 relative">
            //       {productsWelding.map((product) => (
            //         <div>
            //           <Product_comp
            //             key={product.id}
            //             title={product.name}
            //             href={`/products/${product.id}`}
            //             background={{
            //               backgroundImage: `url(${product.image})`,
            //             }}
            //             method={product.title}
            //             description={truncatedDesc}
            //           />
            //         </div>
            //       ))}
            //     </div>
            //   </>
            // ) :
            //  product?.id == "11" ? (
            //   <>
            //     <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-4 mt-9 mb-9 relative">
            //       {productsPlasma.map((product) => (
            //         <div>
            //           <Product_comp
            //             key={product.id}
            //             title={product.name}
            //             href={`/products/${product.id}`}
            //             background={{
            //               backgroundImage: `url(${product.image})`,
            //             }}
            //             method={product.title}
            //             description={truncatedDesc}
            //           />
            //         </div>
            //       ))}
            //     </div>
            //   </>
            // ) :
            //  product?.id == "20" ? (
            //   <>
            //     <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-4 mt-9 mb-9 relative">
            //       {productsPress.map((product) => (
            //         <div>
            //           <Product_comp
            //             key={product.id}
            //             title={product.name}
            //             href={`/products/${product.id}`}
            //             background={{
            //               backgroundImage: `url(${product.image})`,
            //             }}
            //             method={product.title}
            //             description={truncatedDesc}
            //           />
            //         </div>
            //       ))}
            //     </div>
            //   </>
            // ) : 
            // product?.id == "21" ? (
            //   <>
            //     <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-4 mt-9 mb-9 relative">
            //       {productsShearing.map((product) => (
            //         <div>
            //           <Product_comp
            //             key={product.id}
            //             title={product.name}
            //             href={`/products/${product.id}`}
            //             background={{
            //               backgroundImage: `url(${product.image})`,
            //             }}
            //             method={product.title}
            //             description={truncatedDesc}
            //           />
            //         </div>
            //       ))}
            //     </div>
            //   </>
            // ) : (
            //   ""
            // )}
          </>
        ) : ( */}

          <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-7 mb-7">
            <div className="col-span-2">
              {
                product?.image ?
                  <img
                    src={product?.image || "https://placehold.co"}
                    width={imageWidth}
                    height={imageHight}
                    className="rounded-lg max-lg:mb-5"
                    alt={product?.name}
                    onError={(e) => {
                      e.currentTarget.src = "https://placehold.co";
                    }}
                  />
                  :
                  <div className="h-full ml-5 bg-[#f7f4f775] flex items-center justify-center rounded-3xl">
                    <span className="text-gray-400 text-sm">
                      {t("No Image Available")}
                    </span>
                  </div>

              }

            </div>
            <div>
              <div>
                <div className="bg-[#101010] p-12 rounded-3xl">
                  <h3 className="text-[#d9d640] text-2xl tracking-widest">
                    {language === "en" ? product?.name : product?.nameAr}
                  </h3>

                  {
                    (product?.id === 24 || product?.id === 17 || product?.id === 20) ? null :
                      <h3 className="text-[#a2a2a3] text-xl mt-5">
                        {t("Working Area")}
                      </h3>
                  }

                  {(language === "en" ? product?.details?.workingArea : product?.details?.workingAreaAr)?.map((w, index) => (
                    <div key={index}>
                      <p className="text-[#ffffff] text-xl mt-2">{w}</p>
                    </div>
                  ))}
                </div>
                {/* <div className="flex bg-[#3baec1] text-white rounded-2xl mt-5 p-5 text-xl">
                  <a href={mailtoLink} className="flex items-center">
                    <MailOutlined />
                    <p className="mx-4">{t("Email us")}</p>
                  </a>
                </div> */}
                <div className={`flex bg-green-500 hover:bg-green-600 text-white rounded-2xl mt-5 text-xl ${language === "en" ? "" : ""} z-50`}>
                  <a
                    // href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                    //   `${refCode} ${language === "en" ? message : messageAr} ( ${language === "en" ? product?.name : product?.nameAr} )`
                    // )}`}
                    href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(fullText)}`}
                    onClick={() => {
                      // إرسال إحصائية للنظام أو Analytics
                      console.log("Customer clicked WhatsApp link from website");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-white p-3 max-lg:p-2 rounded-full  transition-colors duration-300"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                      alt="WhatsApp"
                      className="w-8 h-8"
                    />
                    <span className="mx-4">{t("Chat with us")}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className=" mt-7 mb-7">
            <div className="col-span-2 lg:ml-6">
              {/* <h3 className="text-[#1c1c1c] text-3xl">Product Parameters</h3> */}
              <p className="mt-5 mb-5 text-lg text-[#ffffff]">
                {language === "en" ? product?.desc : product?.descAr}
              </p>

              {product?.video && (
                <div className="w-full max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-lg bg-black">
                  <video
                    className="w-full h-auto aspect-video object-cover"
                    autoPlay
                    muted
                    loop
                    playsInline
                    controls
                  >
                    <source src={product.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              )}

              <div className="mt-12">
                <h3 className="mt-8 text-3xl font-semibold text-[#ffffff]"> {t("Key Features")}</h3>

                <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-6 mt-6">
                  {product?.details?.keyFeatures?.length > 0 &&
                    product?.details?.keyFeatures?.map((section) => (
                      <div key={section.title} className="bg-[#d9d64029] p-5 rounded-3xl">
                        {/* <h3 className="text-[#1c1c1c] text-xl font-semibold">{section.title}</h3> */}

                        <div className="w-fit text-[17px] font-[700] p-[2px] rounded-full bg-gradient-to-r from-black via-[#c5c23a] to-[#d9d640]">
                          <div className="flex items-center gap-2 rounded-full bg-white px-4 py-2">
                            <div
                              className="rounded-full p-1"
                              style={{
                                background:
                                  "linear-gradient(to top right, #d9d640, #c5c23a, #d9d640)",
                              }}
                            ></div>
                            <p className="text-black">{language === "en" ? section.title : section.titleAr}</p>
                          </div>
                        </div>

                        {(language === "en" ? section.points : section.pointsAr)?.map((p) => (
                          <p className="text-[#ffffff] text-lg mt-2" key={p}>{p}</p>
                        ))}
                      </div>
                    ))}
                </div>
              </div>

              {/* <div className="mt-12">
                  <h2 className="text-3xl font-semibold  text-[#1c1c1c] text-center"> Applications</h2>
                  <hr className={`${styles.line} mx-auto text-center mt-3 mb-6`} />

                  <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-6 mt-9">
                    {product?.details?.applications?.map((section) => (
                      <div key={section.category}>
                        <h3 className="text-[#1c1c1c] text-xl text-center">{section.category}</h3>
                        {section.items.map((i) => (
                          <p className="text-[#8d8e99] text-lg mt-2 text-center" key={i}>{i}</p>
                        ))}
                      </div>
                    ))}
                  </div>
                </div> */}

              <div className="mt-12">
                <h2 className="text-3xl font-semibold text-[#ffffff] text-center">
                  {t("Applications")}
                </h2>
                <hr className={`${styles.line} mx-auto text-center mt-3 mb-10`} />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                  {product?.details?.applications?.map((section, idx) => (
                    <div
                      key={section.category}
                      className="
          relative group p-7 rounded-3xl border border-gray-200 
          bg-[#101010] backdrop-blur-xl shadow-md 
          hover:shadow-xl transition-all duration-300 hover:-translate-y-1
        "
                    >
                      {/* Circle Number */}
                      <div className="
          absolute -top-4 -left-4 bg-gradient-to-br from-[#d9d640] via-[#c5c23a] to-[#d9d640]
          text-white w-10 h-10 rounded-full flex items-center justify-center
          shadow-md font-semibold
        ">
                        {idx + 1}
                      </div>

                      {/* Category Title */}
                      <h3 className="text-[#c5c23a] text-xl font-semibold text-center mb-5 
          group-hover:text-[#c5c23a] transition-all duration-300">
                        {language === "en" ? section.category : section.categoryAr}
                      </h3>

                      {/* Items List */}
                      <div className="flex flex-col gap-3">
                        {(language === "en" ? section.items : section.itemsAr)?.map((item) => (
                          <div
                            key={item}
                            className="flex items-center gap-3 text-lg 
                text-[#6a6b75] group-hover:text-[#50515a] transition-all"
                          >
                            <span className="
                w-2.5 h-2.5 rounded-full 
                bg-gradient-to-br from-[#d9d640] to-[#c5c23a]
              "></span>
                            <p>{item}</p>
                          </div>
                        ))}
                      </div>

                      {/* Hover Glow Border Effect */}
                      <div className="
          absolute inset-0 rounded-3xl border-2 border-transparent 
          group-hover:border-[#d9d640] transition-all duration-300 pointer-events-none
        "></div>
                    </div>
                  ))}
                </div>
              </div>


              <div className="mt-12">
                <h2 className="text-3xl font-semibold text-[#ffffff] text-center">
                  {t("Advantages")}
                </h2>
                <hr className={`${styles.line} mx-auto text-center mt-3 mb-6`} />

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {(language === "en" ? product?.details?.advantages : product?.details?.advantagesAr)?.map((adv, i) => (
                    <div
                      key={i}
                      className="group p-6 rounded-2xl border-2 border-black bg-white shadow-sm 
                   hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                    >
                      <div className="flex items-center gap-4">
                        {/* Icon */}
                        <div className=" flex items-center justify-center rounded-xl 
                          bg-gradient-to-br from-[#d9d640] via-[#c5c23a] to-[#d9d640] 
                          text-white text-2xl font-bold shadow-md group-hover:scale-110 
                          transition-all duration-300">
                          <p className="w-10 h-10 flex mx-auto text-center justify-center items-center">✓</p>
                        </div>

                        {/* Text */}
                        <p className="text-lg font-medium text-[#333] leading-relaxed">
                          {adv}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {
                (product?.rate == 0 || product?.rate === null) ? null :
                  <div className="mt-16">
                    <h2 className="text-3xl font-semibold text-[#ffffff] text-center">
                      {t("Reviews")}
                    </h2>

                    <hr className={`${styles.line} mx-auto mt-3 mb-8`} />

                    {/* Average Rating */}
                    <div className="flex flex-col items-center mb-10">
                      <div className="flex items-center gap-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <Star
                            key={star}
                            size={22}
                            // fill="#d9d640"
                            fill={star <= product?.rate ? "#d9d640" : "none"}
                            color="#d9d640"
                          />
                        ))}
                      </div>

                      <p className="text-3xl font-bold mt-3">{product?.rate}.0</p>

                      <span className="text-gray-500">
                        ({product?.reviews?.length || 0} Reviews)
                      </span>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {product?.reviews?.map((review) => (
                        <div
                          key={review.id}
                          className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all"
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                              <UserCircle
                                size={48}
                                className="text-gray-400"
                              />

                              <div>
                                <h4 className="font-semibold text-lg text-black">
                                  {review.userName || "Username"}
                                </h4>

                                <p className="text-sm text-gray-400">
                                  {review.createdAt}
                                </p>
                              </div>
                            </div>

                            <div className="flex gap-1">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <Star
                                  key={star}
                                  size={18}
                                  fill={star <= review.rating ? "#d9d640" : "none"}
                                  color="#d9d640"
                                />
                              ))}
                            </div>
                          </div>

                          <p className="mt-5 text-gray-600 leading-7">
                            {review.comment}
                          </p>
                        </div>
                      ))}
                    </div>

                    {product?.reviews?.length === 0 && (
                      <div className="text-center py-12">
                        <p className="text-gray-500 text-lg">
                          {t("No reviews yet")}
                        </p>
                      </div>
                    )}
                  </div>

              }


              {/* <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1">
                  <h3 className="text-xl">Model</h3>
                  <p className="text-lg text-[#54545f]">1325, 2040, 2060</p>
                </div> */}
              {/* <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-3">
                  <h3 className="text-xl">Working Size</h3>
                  <p className="text-lg text-[#54545f] col-span-2">
                    3000×1500mm, 4000x1500mm, 6000x1500mm
                  </p>
                </div> */}
              {/* <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-3">
                  <h3 className="text-xl">Laser Power</h3>
                  <p className="text-lg text-[#54545f]">1000-3000w</p>
                </div>
                <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-3">
                  <h3 className="text-xl">Linkage speed</h3>
                  <p className="text-lg text-[#54545f]">100m/min</p>
                </div>
                <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-3">
                  <h3 className="text-xl">Positioning Accuracy</h3>
                  <p className="text-lg text-[#54545f]">±0.05mm</p>
                </div>
                <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-3">
                  <h3 className="text-xl">Repeatability</h3>
                  <p className="text-lg text-[#54545f]">±0.03mm</p>
                </div>
                <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-1 mt-3">
                  <h3 className="text-xl">Maximum Acceleration</h3>
                  <p className="text-lg text-[#54545f]">1.0G</p>
                </div> */}
            </div>
          </div>



          {/* <div>
          <h2 className="text-center text-4xl mt-9">Features</h2>
          <hr className={`${styles.line} mx-auto text-center mt-3`} />
          <div className="grid grid-cols-2 max-xl:grid-cols-1 gap-4 mt-9">
            <div>
              <h3 className="text-2xl mt-5 mb-5">
                Machine Body--Welding Machine Body
              </h3>
              <div className="flex items-center">
                <CaretRightOutlined />
                <p className="ml-3 text-xl">
                  High strength, not easily deformed
                </p>
              </div>
              <p className="text-lg mt-2 text-[#54545f]">
                The following features ensure that the bed will not be deformed
                for 20 years like high strength, good stability and strong
                tensile strength.
              </p>
              <div className="flex items-center mt-5">
                <CaretRightOutlined />
                <p className="ml-3 text-xl">More stable</p>
              </div>
              <p className="text-lg mt-2 text-[#54545f]">
                The rectangular tube has a wall thickness of 6 mm and the entire
                body weighs 3,000 kg.
              </p>
            </div>
            <div className="mx-auto">
              <Image
                src="/../products/9.png"
                width={400}
                height={300}
                className="rounded-lg mx-auto"
              />
            </div>
          </div>
        </div> */}
        </div>

        <div className="px-24 max-xl:px-10">
          <h2 className="text-4xl mt-14">{t("You Also Might Like")}</h2>
          <hr className={`${styles.line} mt-3`} />

          <div className="grid grid-cols-3 max-xl:grid-cols-1 gap-4 mt-9 mb-9 relative">
            {visibleProducts.map((product) => (
              <div>
                <Product_comp
                  key={product.id}
                  title={(language === "en" ? product.name : product.nameAr) || product.name}
                  href={`/products/${product.id}`}
                  background={product.image_small || "empty.jpg"}
                  method={(language === "en" ? product.title : product.titleAr) || product.title}
                  description={(language === "en" ? product.desc : product.descAr) || product.desc}
                  rate={product.rate}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
